var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('UtilityBar',{attrs:{"shouldToggle":true,"userFilter":true},on:{"getHolidays":_vm.manageGetHolidays}}),_c('HolidayTable',{attrs:{"tableHeader":_vm.tableHeader}}),_c('ActionModal',{on:{"closeModal":_vm.closeModal2}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }